import React, { KeyboardEventHandler, MouseEventHandler } from 'react';
import { AccountCircle } from '@naf-simba/building-blocks-icons/User';
import { useDispatch } from 'react-redux';
import { MEMBERPAGES_URL } from '@lib/constants';
import { useGTMDataLayer } from '../../../hooks/GTM/useGTMDataLayer';
import { actions as userActions } from '../../../redux/modules/user';
import { ProfileMenu } from '../../ProfileMenu/ProfileMenu';
import { useLoginRedirect } from '../../../hooks/useLoginRedirect';
import * as S from './MemberArea.styles';

interface MemberAreaProps {
  accountName: string;
  isMyNafEnabled: boolean;
  isLoading: boolean;
  onProfileMenuClick: () => void;
  showProfileMenu: boolean;
  setShowProfileMenu: React.Dispatch<React.SetStateAction<boolean>>;
  isAuthenticated: boolean;
}

const MemberArea = ({
  accountName,
  onProfileMenuClick,
  showProfileMenu,
  setShowProfileMenu,
  isAuthenticated,
  isMyNafEnabled,
  isLoading,
}: MemberAreaProps) => {
  const dataLayer = useGTMDataLayer();
  const dispatch = useDispatch();
  const { redirectToLoginPage } = useLoginRedirect();

  const performLoginAction = () => {
    dataLayer?.push({
      event: 'navbarClick',
      menuPage: window.location.pathname,
      menuSectionName: 'navbarMenuClick',
      menuItemName: 'Logg inn',
      menuItemUrl: 'mitt-naf',
    });

    dataLayer?.push({
      event: 'menu_click',
      menuPage: window.location.pathname,
      menuSectionName: 'navbarMenuClick',
      menuItemName: 'Logg inn',
      menuItemUrl: 'mitt-naf',
    });
    dispatch(userActions.closeMenu());

    redirectToLoginPage(`/${MEMBERPAGES_URL}`);
  };

  const handleLoginClick: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> = (event) => {
    event.preventDefault();
    performLoginAction();
  };

  const handleKeyPress: KeyboardEventHandler<HTMLAnchorElement | HTMLButtonElement> = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      performLoginAction();
    }
  };
  const showLoginButton = !isAuthenticated && !isLoading && isMyNafEnabled;
  const showProfileButtons = isAuthenticated && isMyNafEnabled;

  return (
    <S.ProfileMenuWrapper>
      {showLoginButton && (
        <S.UserButton
          to={`/${MEMBERPAGES_URL}`}
          onClick={handleLoginClick}
          onKeyDown={handleKeyPress}
          size="small"
          textWrap="nowrap"
        >
          Logg inn
        </S.UserButton>
      )}
      {showProfileButtons && (
        <>
          <S.UserButton
            aria-label="Profilmeny"
            onClick={onProfileMenuClick}
            startIcon={AccountCircle}
            size="small"
            textWrap="nowrap"
          >
            {accountName}
          </S.UserButton>
          {showProfileMenu && <ProfileMenu onClick={() => setShowProfileMenu(false)} />}
        </>
      )}
    </S.ProfileMenuWrapper>
  );
};

export default MemberArea;
